module.exports = __webpack_public_path__ + "media/images/flags/64/Nauru-95dceb0787ef25f2b7e8d512779baf84.png";